"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.setOpen = exports.get = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var stevieTexts2_sidecar_1 = require("@uiParts/stevieTexts2-sidecar");
var echoFonts_sidecar_1 = require("@echo/echoFonts-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var voyageGameStatus_sidecar_1 = require("@voyage/game-status/voyageGameStatus-sidecar");
var voyageLayers_sidecar_1 = require("@voyage/scene/voyageLayers-sidecar");
var voyageSystemsData_1 = require("@voyage/systems/voyageSystemsData");
var voyageUiBuyStuff_sidecar_1 = require("@voyage/ui/voyageUiBuyStuff-sidecar");
var voyageUiCanvas_sidecar_1 = require("@voyage/ui/voyageUiCanvas-sidecar");
var voyageUiGButtons_sidecar_1 = require("@voyage/ui/voyageUiGButtons-sidecar");
var voyageUiNav_sidecar_1 = require("@voyage/ui/voyageUiNav-sidecar");
var _obj = null;
function get() {
    if (!_obj) {
        _obj = create();
        exports.setOpen(false, null);
        addButtons();
        render();
    }
    return _obj;
}
exports.get = get;
var create = function () {
    var tw = 700;
    var th = 800;
    var canvas = voyageUiCanvas_sidecar_1.voyageUiCanvas.create(tw, th, voyageLayers_sidecar_1.voyageLayers.getLayers().uiOnCam);
    canvas.autoOffset = false;
    canvas.ox = 0;
    canvas.oy = 0;
    var obj = voyageUiCanvas_sidecar_1.voyageUiCanvas.assign(canvas, {
        button1: null,
        tile: null,
    });
    return obj;
};
var isSystem = function (type) {
    var obj = get();
    if (!obj.tile) {
        return false;
    }
    return false;
    // if (!obj.tile.system) {
    //   return false
    // }
    // return obj.tile.system.data.type === type
};
var addButtons = function () {
    var x = 20;
    var y = 40;
    var obj = get();
    var addButton = function (text, action) {
        var button = voyageUiGButtons_sidecar_1.voyageUiGButtons.create(text, x, y, action);
        button.w = 200;
        obj.buttons.push(button);
        return button;
    };
    obj.buttons = [];
    var gb = voyageCamera_sidecar_1.voyageCamera.getGameBounds();
    x = 100;
    y = gb.height - 250;
    if (isSystem(voyageSystemsData_1.EVoyageSystemType.Nav)) {
        obj.button1 = addButton('Starmap', function () {
            voyageUiNav_sidecar_1.voyageUiNav.setOpen(true);
        });
    }
    if (isSystem(voyageSystemsData_1.EVoyageSystemType.Coms)) {
        obj.button1 = addButton('Purchase', function () {
            voyageUiBuyStuff_sidecar_1.voyageUiBuyStuff.setOpen(true);
        });
    }
};
var render = function () {
    var obj = get();
    var g = obj.graphics;
    voyageUiCanvas_sidecar_1.voyageUiCanvas.clear(obj);
    if (!obj.isOpen || !obj.tile) {
        return;
    }
    var addText = function (text, x, y, scale) {
        if (scale === void 0) { scale = 1; }
        var _text = stevieTexts2_sidecar_1.stevieTexts2.create(echoFonts_sidecar_1.echoFonts.getData().font6, x, y, obj.layer);
        stevieTexts2_sidecar_1.stevieTexts2.setText(_text, text);
        stevieTexts2_sidecar_1.stevieTexts2.setScale(_text, 3 * scale);
        obj.texts.push(_text);
        return _text;
    };
    var x = 0;
    var y = 0;
    var gb = voyageCamera_sidecar_1.voyageCamera.getGameBounds();
    x = obj.tile.x + 32;
    y = obj.tile.y;
    // addText('Nav', x, y, 2) // + 25 - 2)
    // y += 24
    var status = voyageGameStatus_sidecar_1.voyageGameStatus.get();
    if (status.power > 0) {
        if (isSystem(voyageSystemsData_1.EVoyageSystemType.Nav)) {
            addText('Currently at ' + status.locationName, x, y);
            y += 24;
            addText('Jump drive ' + status.jumpCharge + '%', x, y);
            y += 24;
            assert_sidecar_1.assert.notNil(obj.button1);
            obj.button1.x = x;
            obj.button1.y = y;
            obj.button1.inGameSpace = true;
        }
        if (isSystem(voyageSystemsData_1.EVoyageSystemType.Coms)) {
            if (status.isAtStarbase) {
                addText('Communicating with ' + status.locationName, x, y);
                y += 24;
            }
            addText('Spacebucks: $' + status.money, x, y);
            y += 24;
            assert_sidecar_1.assert.notNil(obj.button1);
            obj.button1.x = x;
            obj.button1.y = y;
            obj.button1.inGameSpace = true;
        }
        if (isSystem(voyageSystemsData_1.EVoyageSystemType.SensorExternal)) {
            if (status.enemyShip.active) {
                addText('Enemy ship detected', x, y);
            }
            else {
                addText('Clear', x, y);
            }
        }
        if (isSystem(voyageSystemsData_1.EVoyageSystemType.SensorInternal)) {
            var detected = false;
            if (status.hasBreach.isActive) {
                detected = true;
                addText('Hull breach detected', x, y);
                y += 24;
            }
            if (status.hasFire.isActive) {
                detected = true;
                addText('Fire detected', x, y);
                y += 24;
            }
            if (status.hasBoarders.isActive) {
                detected = true;
                addText('Invaders detected', x, y);
                y += 24;
            }
            if (!detected) {
                addText('Clear', x, y);
                y += 24;
            }
            addText('Oxygen: ' + status.oxygen, x, y);
            y += 24;
            addText('Power: ' + status.power, x, y);
            y += 24;
        }
    }
    if (isSystem(voyageSystemsData_1.EVoyageSystemType.Reactor)) {
        addText('Power: ' + status.power, x, y);
        y += 24;
    }
    if (isSystem(voyageSystemsData_1.EVoyageSystemType.LifeSupport)) {
        addText('Oxygen: ' + status.oxygen, x, y);
        y += 24;
    }
    if (isSystem(voyageSystemsData_1.EVoyageSystemType.JumpDrive)) {
        addText('Jump Drive: ' + status.jumpCharge, x, y);
        y += 24;
    }
    // if (isSystem(EVoyageSystemType.TorpedoLoader)) {
    //   if (obj.tile) {
    //     addText(
    //       voyageSystems_torpedoLoader.getIsLoaded(obj.tile)
    //         ? 'Loaded'
    //         : 'Not loaded',
    //       x,
    //       y,
    //     )
    //     y += 24
    //   }
    // }
    voyageUiCanvas_sidecar_1.voyageUiCanvas.render(obj);
};
var setOpen = function (isOpen, tile) {
    if (tile === void 0) { tile = null; }
    var obj = get();
    obj.tile = tile;
    if (isOpen && !obj.isOpen) {
        addButtons();
    }
    voyageUiCanvas_sidecar_1.voyageUiCanvas.setOpen(obj, isOpen);
    exports.update();
};
exports.setOpen = setOpen;
var update = function () {
    var obj = get();
    voyageUiCanvas_sidecar_1.voyageUiCanvas.update(obj);
    render();
};
exports.update = update;
